export default "__VITE_ASSET__CM6VXRu8__"